import { ICardPlanTax } from "./interface"
import React, {useEffect, useState} from "react";

import Header from "../Header";
import NavTabs from "../NavTabs";

import {
    Container,
    Card,
    CardPlanNameAndStatusContainer,
    CardPlanName,
    CardPlanStatus,
    CardPlanDescription,
    CardPaymentOptionsContainer,
    CardPaymentOptionsTitleRow,
    CardPaymentOptionsTitle,
    CardPaymentOptionsDetail,
    CardPaymentOptionsDetailDescription,
    TableContainer,
    Thead,
    TH,
    TD
} from "./styles";

import { translatePaymentType } from "../../utils/translate/paymentType";

const CardPlanTax = (props: ICardPlanTax) => {

    const [isDebitDetailShowed, setIsDebitDetailShowed] = useState(false);
    const [isBoletoDetailShowed, setIsBoletoDetailShowed] = useState(false);
    const [isCreditDetailShowed, setIsCreditDetailShowed] = useState(false);
    const [data, setData] = useState([]);
    const dataTaxPlans = props.plan?.fee_details.sort((a: any,b: any) => {
        return (a -b)
    })

    const debitTableGenerator = () => {
        return(
            <>
                <CardPaymentOptionsDetailDescription>
                    Não Antecipado D+1
                </CardPaymentOptionsDetailDescription>
                <TableContainer>
                    <table className="w-100">
                        <Thead>
                            <TH>Bandeira</TH>
                            <TH style={{textAlign: "end"}}>Taxa</TH>
                        </Thead>
                        {
                            dataTaxPlans.filter((data: any) =>  data.payment_type === "debit").map((data: any) => {
                                return (
                                    <tr>
                                        <TD> {data.card_brand} </TD>
                                        <TD style={{textAlign: "end"}}>
                                            {(data.percent_amount * 10 / 1000).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}%</TD>
                                    </tr>
                                )
                            })
                        }
                    </table>
                </TableContainer>
            </>
        )
    }

    const boletoTableGenerator = () => {
        return(
            <>
                <CardPaymentOptionsDetailDescription>
                    Não Antecipado D+0
                </CardPaymentOptionsDetailDescription>
                <TableContainer>
                    <table className="w-100">
                        <Thead>
                            <TH style={{textAlign: "end", width: "100%"}}>Tarifa</TH>
                        </Thead>
                        {
                            dataTaxPlans.filter((data: any) => data.payment_type === "boleto").map((data: any) => {
                                return (
                                    <tr>
                                        <TD style={{textAlign: "end"}}>
                                            {(data.percent_amount * 10 / 1000).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}%</TD>
                                    </tr>
                                )
                            })
                        }
                    </table>
                </TableContainer>
            </>
        )
    }

    const creditTableGenerator = () => {
        return(
            <>
                <CardPaymentOptionsDetailDescription>
                    Não Antecipado D+1
                </CardPaymentOptionsDetailDescription>
                <TableContainer style={{marginBottom: 0}}>
                    <table className="w-100">
                        <Thead>
                            <TH>Parcelas</TH>
                            <TH>Bandeira</TH>
                            <TH style={{textAlign: "end"}}>Taxa</TH>
                        </Thead>
                        <tbody>
                            {
                                dataTaxPlans.filter((data: any) =>  data.payment_type === "credit").map((data: any) => {
                                    return (
                                        <tr>
                                            <TD> { data.payment_type === "credit" ? data.number_installments + "x": translatePaymentType(data.payment_type)  } </TD>
                                            <TD> {data.card_brand} </TD>
                                            <TD style={{textAlign: "end"}}>
                                                {(data.percent_amount * 10 / 1000).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}%</TD>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </TableContainer>
            </>
        )
    }

    const generateCards = () => {
            return (
                <Container>
                    <Card>
                        <CardPlanNameAndStatusContainer>
                            <CardPlanName> { props.plan?.name } </CardPlanName>
                            <CardPlanStatus>(ativo)</CardPlanStatus>
                        </CardPlanNameAndStatusContainer>

                        <CardPlanDescription>
                            Conheça as condições de recebimento e taxas disponíveis para você.
                        </CardPlanDescription>

                        <CardPaymentOptionsContainer>
                                    <CardPaymentOptionsTitleRow style={{marginBottom: isCreditDetailShowed ? 0 : 27}}>
                                    <CardPaymentOptionsTitle>Débito</CardPaymentOptionsTitle>
                                    <CardPaymentOptionsDetail onClick={() => {
                                            setIsDebitDetailShowed(!isDebitDetailShowed)
                                        }
                                    }>{isDebitDetailShowed ? "Esconder detalhes" : "Ver detalhes"}</CardPaymentOptionsDetail>
                                </CardPaymentOptionsTitleRow>
                                {isDebitDetailShowed ? debitTableGenerator() : null}
                        </CardPaymentOptionsContainer>

                        <CardPaymentOptionsContainer>
                                    <CardPaymentOptionsTitleRow style={{marginBottom: isCreditDetailShowed ? 0 : 27}}>
                                    <CardPaymentOptionsTitle>Crédito</CardPaymentOptionsTitle>
                                    <CardPaymentOptionsDetail onClick={() => {            
                                            setIsCreditDetailShowed(!isCreditDetailShowed)
                                        }
                                    }>Ver detalhes</CardPaymentOptionsDetail>
                                </CardPaymentOptionsTitleRow>
                                {isCreditDetailShowed ? creditTableGenerator() : null}
                        </CardPaymentOptionsContainer>

                        <CardPaymentOptionsContainer>
                                    <CardPaymentOptionsTitleRow style={{marginBottom: isCreditDetailShowed ? 0 : 27}}>
                                    <CardPaymentOptionsTitle>Boleto</CardPaymentOptionsTitle>
                                    <CardPaymentOptionsDetail onClick={() => {
                                            setIsBoletoDetailShowed(!isBoletoDetailShowed)
                                        }
                                    }>Ver detalhes</CardPaymentOptionsDetail>
                                </CardPaymentOptionsTitleRow>
                                {isBoletoDetailShowed ? boletoTableGenerator() : null}
                        </CardPaymentOptionsContainer>
                    </Card>
                </Container>
            )
    }

    return (
        <>
            { generateCards() }
        </>
    )
}

export default CardPlanTax